<template>
  <div>
    <el-dialog
      title="开通钻石版"
      :visible.sync="isShow"
      custom-class="zsb_dialog"
      @close="closeDialog"
      :close-on-click-modal="false"
      v-if="onLines.length"
      width="800px"
    >
      <!-- @open="openDialog" -->
      <!-- 充值账户选择 -->
      <div class="item-box">
        <label>选择套餐：</label>
        <div class="radio-box">
          <el-radio-group v-model="selectedPackage" @change="handleChangePay">
            <el-radio
              border
              v-for="(item, index) in onLines"
              :key="index"
              :label="item.Number"
              style="width: 300px"
              >{{ item.Number }}用户同时在线游戏【{{
                (openDiamondObj && openDiamondObj.Price) +
                item.Price * 30 +
                (netBarInfo && netBarInfo.AddMoneyAmount)
              }}元/月】</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <!-- 选择时长 -->
      <div class="time-box" v-if="netBarInfo && netBarInfo.AddMoneyType == 0">
        <label>选择时长：</label>
        <div class="month-box">
          <el-input-number
            v-model="month"
            :min="1"
            :max="99999"
            :step="1"
            @change="handleChangePay"
          />
          月
          <span class="ps">(*注：1月按30天计算)</span>
        </div>
      </div>
      <div class="item-box" v-else>
        <label>选择时长：</label>

        <div class="radio-box">
          <p class="ps" style="margin-bottom: 10px">(*注：1月按30天计算)</p>
          <el-radio-group v-model="month" @change="handleChangePay">
            <el-radio border :label="1" style="width: 180px">买1个月</el-radio>
            <el-radio border :label="2" style="width: 180px">买2个月</el-radio>

            <el-radio
              border
              v-for="(item, index) in openDiamondList"
              :key="index"
              :label="item.split('_')[0]"
              style="width: 180px"
              >{{
                "买" +
                item.split("_")[0] +
                "个月送" +
                item.split("_")[1] +
                "个月"
              }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <!-- 选择支付方式 -->
      <div class="pay-box">
        <label>选择支付方式：</label>
        <el-radio-group v-model="payWay" @change="handleChangePay">
          <el-radio :label="1" border style="width: 150px">
            <img
              src="@/assets/images/members/zfb.png"
              alt="支付宝"
              style="width: 18px; height: 18px; margin-right: 5px"
            />支付宝
          </el-radio>
          <el-radio :label="2" border style="width: 150px">
            <img
              src="@/assets/images/members/wx.png"
              alt="微信"
              style="width: 18px; height: 18px; margin-right: 5px"
            />微信
          </el-radio>
        </el-radio-group>
      </div>
      <!-- 二维码展示和应付金额 -->
      <div v-if="selectedPackage" class="code-box">
        <div class="code">
          <canvas
            id="canvas"
            ref="canvas"
            style="width: 150px; height: 150px"
            v-if="isRefresh"
          ></canvas>
          <img
            v-else
            src="@/assets/images/members/code1.png"
            width="160px"
            height="160px"
            alt=""
          />
          <div class="refresh" v-if="!isRefresh" @click="refreshQrCode">
            <i class="el-icon-refresh"></i>
            点击刷新支付码
          </div>
        </div>

        <p class="price">应付：￥{{ getTotalPrice }}</p>
      </div>
      <!-- 同意条款 -->
      <div class="xy_box">
        <el-checkbox v-model="agreedTerms" disabled />
        <a href="javascript:;" @click="linkTo" class="agreement"
          >阅读并同意《开通钻石版服务特权》</a
        >
      </div>
    </el-dialog>

    <!-- 支付成功广告弹窗 -->
    <el-dialog
      custom-class="ad-dialog"
      :visible.sync="adDialog"
      width="30%"
      center
      v-if="adObj"
      :close-on-click-modal="false"
    >
      <img
        :src="adObj.ADImageUrl"
        width="100%"
        @click.stop="adToLink(adObj.ADOpenUrl)"
        alt=""
      />
    </el-dialog>
  </div>
</template>

<script>
import { getProducts, pCreateOrder, pOrderPayState } from "@/api";
import { mapGetters } from "vuex";
import QRCode from "qrcode";
import cMethods from "@/util/cMethods.js";

export default {
  props: {
    netBarInfo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["netBarId", "netBarVIP"]),
    getTotalPrice: function () {
      let total = 0;
      if (this.onLines.length) {
        total =
          this.onLines.filter((item) => item.Number === this.selectedPackage)[0]
            .Price * 30;
        if (this.openDiamondObj) {
          total = this.openDiamondObj.Price + total;
        }
        if (this.netBarInfo && this.netBarInfo.AddMoneySwitch == 1) {
          if (this.netBarInfo.AddMoneyAmount) {
            total = total + this.netBarInfo.AddMoneyAmount;
          }
          // 购买月份
          total = total * this.month;
        }
      }
      return total;
    },
  },
  data() {
    return {
      openDiamondList: [],
      isShow: false,
      selectedPackage: 0,
      month: 1,
      payWay: 1, // 支付方式：1.支付宝支付  2.微信支付
      qrCodeUrl: "", // 实际需替换为真实二维码地址
      agreedTerms: true,
      onLines: [],
      openDiamondObj: null,
      orderCode: "",
      timer: null,
      adObj: null,
      adDialog: false,
      isRefresh: false,
    };
  },
  methods: {
    refreshQrCode() {
      this._createOrder();
      this.isRefresh = true;
    },
    async _getOnlines() {
      if (this.netBarInfo) {
        const { AgencyId, ProductPowerInfos } = this.netBarInfo;
        console.log("钻石版套餐...", ProductPowerInfos);
        // 获取网吧终端套餐
        if (AgencyId) {
          let params = {
            agencyId: AgencyId,
          };
          let res = await getProducts(params);
          console.log("res....", res);
          // console.log("当前版本:", this.netBarVIP);
          if (res.StatusCode === 200 && res.Object) {
            this.onLines = res.Object.Onlines.filter((item) => item.Price > 0);
            this.selectedPackage = this.onLines[0].Number;
            // 钻石版过滤非开通套餐
            if (this.netBarVIP) {
              // 开通过钻石版套餐续费时，只显示当前开通套餐对应的终端数套餐
              if (ProductPowerInfos && ProductPowerInfos.length) {
                const { Online, IsOnlineExpire } = ProductPowerInfos[0];
                if (IsOnlineExpire === "未到期") {
                  this.onLines = res.Object.Onlines.filter(
                    (item) => item.Price > 0 && item.Number === Online
                  );
                  this.selectedPackage = this.onLines[0].Number;
                }
              }
            }
            if (res.Object.Products.length) {
              this.openDiamondObj = res.Object.Products[0];

              if (this.openDiamondObj.Discount) {
                this.openDiamondList = this.openDiamondObj.Discount.split(",");
                // if (this.openDiamondList.length) {
                //   this.month = this.openDiamondList[0].split("_")[0];
                //   // this.openDiamondObj.PrivilegeCount = this.month;
                // }
              }
            }

            this._createOrder();
            this.isRefresh = true;
          }
        }
      }
    },
    async openDialog() {
      this._getOnlines();
      this.isShow = true;
    },

    closeDialog() {
      clearInterval(this.timer);
      this.timer = null;
      this.isShow = false;
    },
    async _createOrder() {
      let params = {
        NetbarId: parseInt(this.netBarId),
        Online: this.selectedPackage,
        Count: this.month,
      };
      // console.log("params...", params);
      const res = await pCreateOrder(params);

      if (res.StatusCode == 200) {
        if (this.payWay == 1) {
          this.orderCode = res.Object.PayAliUrl;
        }
        if (this.payWay == 2) {
          this.orderCode = res.Object.PayWeChatUrl;
        }
        let orderNo = res.Object.Id;
        if (this.orderCode) {
          this.setQrCode(this.orderCode, orderNo);
          this.$statistic(["A", "我的会员", "钻石版续费二维码", "展现量"]);
        }
      }
    },
    // 生成二维码
    async setQrCode(OrderCode, OrderNo) {
      // 显示支付二维码弹窗组件
      let canvas = this.$refs.canvas;
      QRCode.toCanvas(canvas, OrderCode, function (error) {
        if (error) console.error(error);
        // console.log("QRCode success!");
      });
      // 查看订单状态
      clearInterval(this.timer);
      this.timer = setInterval(async () => {
        let params = {
          orderId: OrderNo,
        };

        let res = await pOrderPayState(params);
        if (res.StatusCode == 200) {
          console.log("检测支付状态。。。");
          if (res.Object) {
            // 刷新获取网吧版本
            this.$store.dispatch("_GetNetbarInfo", {
              netBarId: parseInt(this.netBarId)
            });
            // 支付成功弹窗
            if (sessionStorage.getItem("adList")) {
              let adArr = JSON.parse(sessionStorage.getItem("adList"));
              if (adArr) {
                this.adObj = adArr.filter(
                  (item) => item.ADName === "客户端购买钻石版支付成功广告"
                )[0];
                this.adDialog = true;
              }
            }
            // 关闭弹窗
            this.closeDialog();
          }
        }
      }, 3000);
    },
    handleChangePay() {
      this.isRefresh = false;
      clearInterval(this.timer);
      this.timer = null;
    },
    // 登录成功弹窗跳转
    adToLink(url) {
      this.adDialog = false;
      this.$router.push(url);
    },
    // 广告跳转
    linkTo() {
      cMethods.OpenIeUrl(
        "http://www.mayidianjing.com/Content/html/ZS_Service_Agreement.html"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.zsb_dialog {
  .item-box {
    display: flex;
    margin-bottom: 20px;

    .radio-box {
      flex: 1;
      .el-radio {
        // margin-right: 0;
        // margin-left: 0;
        margin: 0 5px;
        margin-bottom: 10px;
        @include font_col3();
      }
    }
  }
  label {
    margin-right: 10px;
    @include font_col3();
  }

  .el-radio.is-bordered.is-checked {
    border-color: $red_col;
  }

  .time-box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .month-box {
      display: flex;
      align-items: center;
    }
    .el-input-number {
      width: 160px;
      margin-right: 10px;
    }
    .ps {
      margin-left: 16px;
      @include font_col9();
    }
  }
  .time-box2 {
    display: flex;
    margin-top: 20px;
    .row-box {
      padding-left: 5px;
      .grid-box {
        display: flex;
        justify-content: center;
        padding: 10px;
        margin-bottom: 10px;
        border: 1px solid #dcdfe6;
        @include font_col3();
      }
    }
  }
  .pay-box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .code-box {
    text-align: center;
    margin-bottom: 20px;
    .code {
      width: 164px;
      height: 164px;
      margin: 0 auto;
      position: relative;
      #canvas {
        border: 1px solid #ccc;
      }
      .refresh {
        position: absolute;
        top: 0;
        left: 0;
        width: 164px;
        height: 164px;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 18px;
      }
    }
    .price {
      margin-top: 10px;
      color: $red_col;
      font-size: 18px;
    }
  }
  .xy_box {
    text-align: center;
  }
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: $red_col !important;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: $red_col;
  background: $red_col;
}

::v-deep .el-input__inner {
  border: none;
}
::v-deep .el-input-number__decrease,
::v-deep .el-input-number__increase,
::v-deep .el-input-number__decrease:hover,
::v-deep .el-input-number__increase:hover {
  color: #333;
}

::v-deep .el-radio input[aria-hidden="true"] {
  display: none !important;
}

::v-deep
  .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .el-radio__inner {
  box-shadow: none !important;
}
</style>
